import { rootApi } from '../rootApi';

export const lmsCreateRequestApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsCreateRequests: builder.query({
            query: ({ pageNumber, pageSize, filters, sorts }) => ({
                url: 'v1/LmsCreateRequest/GetList',
                method: 'POST',
                body: {
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10,
                    filters: Array.isArray(filters) ? filters : [],
                    sorts: Array.isArray(sorts) && sorts.length > 0 ? sorts : [{ column: 'CreatedDate', direction: 2 }],
                    includeFilterOptions: false,
                    filterOptionsColumns: null
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsCreateRequest']
        }),

        getLmsCreateRequestById: builder.query({
            query: (id) => ({
                url: 'v1/LmsCreateRequest/GetById',
                method: 'GET',
                params: { Id: id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsCreateRequest']
        }),

        addLmsCreateRequest: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsCreateRequest/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsCreateRequest']
        }),

        updateLmsCreateRequest: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsCreateRequest/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsCreateRequest']
        }),

        deleteLmsCreateRequest: builder.mutation({
            query: (id) => ({
                url: `v1/LmsCreateRequest/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsCreateRequest']
        }),

        // BE'nin istek notumuza (bkz. docs/LMS-Egitim-Talebi-BE-Istek-Notu.md §2) cevabı olarak
        // eklediği uç — bkz. docs/GET v1LmsCreateRequestGetApplicable.txt. Seçilen vehicleModel +
        // trainingType (+ opsiyonel planningLocation) için varsa ilgili Planning kaydının fee/currency
        // bilgisini ve eğitimin ücretli olup olmadığını (isPaid) döner. Eşleşen kayıt yoksa ya da
        // ücret belirlenemiyorsa `feeUnknown: true` döndüğü belgeleniyor. CRUD mutasyonlarından
        // bağımsız bir lookup olduğu için `LmsCreateRequest` tag'ine bağlanmıyor.
        getApplicableFee: builder.query({
            query: ({ vehicleModel, trainingType, planningLocation }) => ({
                url: 'v1/LmsCreateRequest/GetApplicableFee',
                method: 'GET',
                params: {
                    vehicleModel,
                    trainingType,
                    ...(planningLocation ? { planningLocation } : {})
                }
            }),
            transformResponse: (response) => response?.data || null
        }),

        // "Eğitim Türü" alanının seçili "Araç Modeli"ne göre daralması için — bkz.
        // docs/GetTrainingTypesByVehicleModel.txt. Yalnızca o araç modeli için katalogda AKTİF
        // kaydı olan VE en az bir planlaması bugünden 7+ gün sonra başlayan training_type
        // değerlerini döner (TrainingRequestForm.jsx'te bu yüzden yalnızca "Talep" ekranında
        // kullanılıyor — Eğitim Kataloğu ekleme formunda kullanılmaz, orada henüz hiç planlaması
        // olmayan yeni bir tür de seçilebilmeli). `trainingType` seçilince gönderilecek değer
        // cevaptaki `trainingType` (kod) alanıdır, `trainingTypeText` yalnızca görüntü içindir.
        getTrainingTypesByVehicleModel: builder.query({
            query: (vehicleModel) => ({
                url: 'v1/LmsCreateRequest/GetTrainingTypesByVehicleModel',
                method: 'GET',
                params: { vehicleModel }
            }),
            transformResponse: (response) => (Array.isArray(response?.data) ? response.data : [])
        }),

        // "Yayınlanan Eğitimler" akışının 1. adımı — bkz. "docs/LMS EĞİTİM TALEBİ_new-changed.txt"
        // madde 5. Yalnızca katalogda aktif kaydı olan VE en az bir planlaması bugünden 7+ gün sonra
        // başlayan araç modellerini döner ({ vehicleModel, vehicleModelText }[]). Parametre almaz.
        getVehicleModelsWithUpcomingPlannings: builder.query({
            query: () => ({
                url: 'v1/LmsCreateRequest/GetVehicleModelsWithUpcomingPlannings',
                method: 'GET'
            }),
            transformResponse: (response) => (Array.isArray(response?.data) ? response.data : [])
        }),
        getLmsCreateRequestPlannings: builder.query({
            query: ({ vehicleModel, trainingType }) => ({
                url: 'v1/LmsCreateRequest/GetPlannings',
                method: 'GET',
                params: { vehicleModel, trainingType }
            }),
            transformResponse: (response) => (Array.isArray(response?.data) ? response.data : [])
        }),
 
        // Kayıt oluşturmadan bitiş tarihlerini hesaplar — bkz. docs/LMS-Sure-Bitis-Tarihi-FE-Notu.txt §2.
        // İhaledeki LmsTenderRequest/CalculateEndDate ile aynı kalıp; formda anlık gösterim içindir.
        calculateLmsCreateRequestEndDate: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsCreateRequest/CalculateEndDate',
                method: 'POST',
                body: data || {}
            }),
            transformResponse: (response) => response?.data || response || null
        }),

        changeLmsCreateRequestStatus: builder.mutation({
            query: ({ id, newStatus, comment, requestType }) => ({
                url: 'v1/LmsCreateRequest/ChangeStatus',
                method: 'POST',
                body: { id, newStatus, comment: comment || undefined, requestType: requestType ?? undefined }
            }),
            invalidatesTags: ['LmsCreateRequest', 'LmsTenderRequest']
        }),

        // Statü geçmişi/yorumları — bkz. docs/talep_olustur_onay_akısı.md "YORUM GEÇMİŞİ". Yeniden
        // eskiye sıralı döner, `status` alanı yorumun hangi geçişte yazıldığını gösterir.
        // `arg` ya eski usül düz bir requestId (eğitim talebi çağıranları), ya da
        // `{ requestId, requestType }` (ihale ekranı, requestType: 3) olabilir.
        getLmsCreateRequestComments: builder.query({
            query: (arg) => {
                const isObject = arg !== null && typeof arg === 'object';
                const requestId = isObject ? arg.requestId : arg;
                const requestType = isObject ? arg.requestType : undefined;
                return {
                    url: 'v1/LmsCreateRequest/GetComments',
                    method: 'GET',
                    params: { requestId, ...(requestType != null ? { requestType } : {}) }
                };
            },
            transformResponse: (response) => {
                if (Array.isArray(response?.data)) return response.data;
                if (Array.isArray(response)) return response;
                return [];
            }
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsCreateRequestsQuery,
    useGetLmsCreateRequestByIdQuery,
    useAddLmsCreateRequestMutation,
    useUpdateLmsCreateRequestMutation,
    useDeleteLmsCreateRequestMutation,
    useGetApplicableFeeQuery,
    useGetTrainingTypesByVehicleModelQuery,
    useGetVehicleModelsWithUpcomingPlanningsQuery,
    useGetLmsCreateRequestPlanningsQuery,
    useChangeLmsCreateRequestStatusMutation,
    useGetLmsCreateRequestCommentsQuery,
    useCalculateLmsCreateRequestEndDateMutation
} = lmsCreateRequestApi;
